module.exports = __webpack_public_path__ + "images/icons/flags/UA-f74ada46.svg";